import React,{useMemo} from 'react';
import CustomSpreadsheet from '../../components/editors/CustomSpreadsheet';
import {getStudentSpreadsheet,hasStarterSpreadsheet,starterAnswerCells} from '../../utils/starterSpreadsheet';

export default function ExamSpreadsheetResponse({question,answer,onChange}) {
    const prepared=hasStarterSpreadsheet(question),config=question.starterSpreadsheet;
    const data=useMemo(()=>getStudentSpreadsheet(question,answer?.excelData),[question,answer?.excelData]);
    const cells=useMemo(()=>starterAnswerCells(question),[question]);
    const filled=cells.filter(id=>String(data?.cellData?.[id]?.value ?? '').trim()!=='').length;
    return <div className="flex flex-col h-full min-h-0">
        {prepared && <div className="flex-shrink-0 px-4 py-3 bg-amber-50 border-b border-amber-200 text-sm text-gray-700">
            <div className="flex justify-between gap-3"><b>Complete the highlighted cells</b><span>{filled} / {cells.length} filled</span></div>
            {config.instructions && <p className="mt-1">{config.instructions}</p>}
            <p className="mt-1 text-xs text-gray-500">{config.restrictEditing!==false?'Given figures are protected. Tab moves between answer cells. ':'You can edit the sheet. '}Numbers and formulas are accepted.</p>
        </div>}
        <div className="flex-1 min-h-0"><CustomSpreadsheet allowSheets={!prepared} data={data} onChange={onChange} editableCells={prepared && config.restrictEditing!==false?cells:undefined} highlightedCells={prepared?cells:undefined}/></div>
    </div>;
}
